<template>
<div class="main-container">

<section id="programacao" class="programacao">
    <div class="container">

        <header class="section-header">
          <h2>Conheça nossa</h2>
          <h1>Programação</h1>
          <p>Veja toda nossa grade e monte sua própria agenda.</p>
        </header>
        <div class="text-center" v-show="isLoading">
          <div class="loading"><img src="@/assets/images/spinner.svg" width="100" height="100"></div>
        </div>
        <div class="row" v-show="!isLoading">
          <div class="calendar-container">
            <div class="event-day-container" v-show="selectedDia === null || Object.keys(selectedDia).length == 0 || selectedDia.date == '2022-07-26'">
              <div class="calendar-title d-flex">
                <h3 class="flex-fill">Dia 26</h3>
                <p class="proximo-dia"><a href="#" v-scroll-to="{ el: '#dia-27', offset: -230 }">Ver dia 27</a></p>
              </div>
              
              <MyCalendar id="dia-26" :talks="returnTalks" type="main" :palcos="palcosPrincipais" dia="2022-07-26" />

              <MyCalendar :talks="returnTalks" type="secondary" :palcos="palcosAdicionais" dia="2022-07-26" />

              <MyCalendar :talks="returnTalks" type="sponsor" :palcos="palcosPatrocinadores" dia="2022-07-26" />

            </div>
            <div class="event-day-container" v-show="selectedDia === null || Object.keys(selectedDia).length == 0 || selectedDia.date == '2022-07-27'">
              <div class="calendar-title d-flex">
                <h3 class="flex-fill">Dia 27</h3>
                <p class="proximo-dia"><a href="#" v-scroll-to="{ el: '#dia-26', offset: -230 }">Ver dia 26</a></p>
              </div>
              <MyCalendar id="dia-27" :talks="returnTalks" type="main" :palcos="palcosPrincipais" dia="2022-07-27" />

              <MyCalendar :talks="returnTalks" type="secondary" :palcos="palcosAdicionais" dia="2022-07-27" />

              <MyCalendar :talks="returnTalks" type="sponsor" :palcos="palcosPatrocinadores" dia="2022-07-27" />

            </div>

          </div>
        </div>
    </div>

</section>

</div>
</template>
<script>

  import MyCalendar from '../components/MyCalendar'

  export default {
    components: {
      MyCalendar,
    },
    data() {
      return {
        returnTalks: [],
        talks: [],
        searchField: "",
        selectedPalcos: [],
        selectedDia: {},
        selectedHorario: {},
        palcoFake: {id: 'x', title: ' ', order: 99999},
        palcos: [],
        palcosLoaded: false,
        isLoading: true,
      };

    },
    computed: {
      palcoOptions() {
        return this.palcos.concat(this.palcoFake);
      },
      palcosPrincipais() {
        return this.palcos.filter(function(palco) {
            return palco.type == 'principal';
        });
      },
      palcosAdicionais() {
        return this.palcos.filter(function(palco) {
            return palco.type == 'complementar';
        });
      },
      palcosPatrocinadores() {
        return this.palcos.filter(function(palco) {
            return palco.type == 'patrocinador';
        });
      }
    },
    methods: {
      getTalkById(id) {
        let theTalk = this.returnTalks.filter(function(ob) {
          return ob.id == id;
        })
        return theTalk[0];
      },
      formatTime(d) {
        let hora = ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        return hora;
      },
      filterPalcos() {
        let palcos = this.palcoOptions;
        let vm = this;

        if (this.selectedPalcos !== null && this.selectedPalcos !== undefined && this.selectedPalcos.length > 0) {

          palcos = palcos.filter(function(o1){
              // filter out (!) items in result2
              return vm.selectedPalcos.some(function(o2){
                  return o1.id === o2.id || o1.id == "x";          // assumes unique id
              });
          })
        }

        return palcos;
      },
      getTalks() {
        this.$getTalks().then(response => {
          this.returnTalks = response;
        });
      },
      getPalcos() {
        this.$getPalcos().then(response => {
          this.palcos = response;
          this.isLoading = false;
        });
      }

    },
    mounted() {

      this.getTalks();
      this.getPalcos();

    },

  }
</script>
<style lang="scss">

</style>